import styled from "styled-components";

export const Card = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.lg}px;
  padding: 16px 16px 4px;
  margin: 0 14px 14px;
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  border: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
`;

export const IconBadge = styled.span`
  width: 34px;
  height: 34px;
  border-radius: 11px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Title = styled.div`
  font-weight: 900;
  font-size: 15.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Sub = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 1px;
`;
